exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".archi_content[data-v-7f6a9aec]{padding-top:12px}.logo[data-v-7f6a9aec]{width:384px}.architecture[data-v-7f6a9aec]{padding:20px 40px}", ""]);

